import { ref } from "vue";
import type { Ref } from "vue";
type ActiveTab = [Ref<string>, (key: string) => void];
const activeKey = ref<string>("");
export default (): ActiveTab => {
  const setActiveKey = (key: string) => {
    /** important: use decode url */
    // console.log(decodeURIComponent(key),'decodeURIComponent(key)')
    // let newKey = decodeURIComponent(key)
    // if(newKey.startsWith("/#")){
    //   newKey = newKey.substring(2)
    // }
    // console.log(newKey,'newKey')
    activeKey.value = decodeURIComponent(key);
  };
  return [activeKey, setActiveKey];
};
